import type { ReactNode } from 'react'
import { Link } from 'react-router-dom'

import type { User } from '@/api/types'
import { Avatar } from '@/components/ui/Avatar'

import { FollowButton } from './FollowButton'

/** 用户列表的一行。`actions` 给了就替换右侧的关注按钮（比如关注请求页的批准 / 拒绝）。 */
export function UserListItem({ user, actions }: { user: User; actions?: ReactNode }) {
  return (
    <Link
      to={`/${user.username}`}
      className="flex gap-3 border-b border-line px-4 py-3 transition-colors hover:bg-surface-hover"
    >
      <Avatar src={user.avatar_url} alt={user.display_name} />
      <div className="min-w-0 flex-1">
        <div className="flex items-start gap-2">
          <div className="min-w-0 flex-1">
            <p className="truncate font-bold">{user.display_name}</p>
            <p className="truncate text-[15px] text-ink-muted">@{user.username}</p>
          </div>
          {actions ?? <FollowButton user={user} size="sm" />}
        </div>
        {user.bio && <p className="post-text mt-1 text-[15px]">{user.bio}</p>}
      </div>
    </Link>
  )
}
